export default "__VITE_ASSET__DTlOCmp$__"